import type { SalesOrderLineItem, SalesOrderShipmentSummary } from '@erp/rpc';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { T } from 'gt-react';
import { SalesOrderLineItemRow } from './sales-order-line-item-row';

interface SalesOrderLineItemsProps {
  salesOrderId: string;
  lineItems: SalesOrderLineItem[];
  currency?: string | null;
  shipment?: SalesOrderShipmentSummary | null;
}

export function SalesOrderLineItems({
  salesOrderId,
  lineItems,
  currency,
  shipment,
}: SalesOrderLineItemsProps) {
  if (lineItems.length === 0) {
    return (
      <div className="p-4 text-center text-sm text-muted-foreground">
        <T>No line items found</T>
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[60px]">#</TableHead>
          <TableHead>
            <T>Product</T>
          </TableHead>
          <TableHead className="text-right">
            <T>Qty</T>
          </TableHead>
          <TableHead className="text-right">
            <T>Sale Price</T>
          </TableHead>
          <TableHead className="text-right">
            <T>Supplier Cost</T>
          </TableHead>
          <TableHead className="text-right">
            <T>Total</T>
          </TableHead>
          <TableHead>
            <T>Delivery</T>
          </TableHead>
          <TableHead>
            <T>Continuity</T>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {lineItems.map((item, index) => (
          <SalesOrderLineItemRow
            key={item.id}
            item={item}
            index={index}
            salesOrderId={salesOrderId}
            currency={currency}
            shipment={shipment}
          />
        ))}
      </TableBody>
    </Table>
  );
}
